<template>
  <div id="category-create">
    <div class="page-header">
      <h1 class="page-header-title">
        <span class="fa fa-fw fa-sitemap"></span>
        {{ pageTitle }}
      </h1>
      <div class="page-header-actions page-header-actions--right-position">
        <div class="form-inline">
          <div class="form-group">
            <div class="btn-group">
              <button class="btn btn-default" type="button" @click="cancel" :disabled="fetchingData">Cancel</button>
              <button class="btn btn-primary" type="button" @click="save" :disabled="fetchingData">Save</button>
              <button class="btn btn-default" type="button" @click="saveAndExit" :disabled="fetchingData">Save &amp; Exit</button>
              <button class="btn btn-default" type="button" @click="back" :disabled="fetchingData">Back</button>
            </div>
            <div class="form-group">
              <div class="form-inline__divider"></div>
            </div>
            <div class="btn-group">
              <button class="btn btn-danger" type="button" @click="deleteCategory" :disabled="fetchingData">Delete</button>
            </div>
            <div class="form-group">
              <div class="form-inline__divider"></div>
            </div>
            <div class="btn-group">
              <button type="button" class="btn btn-default" @click.prevent="reload" :disabled="fetchingData"><i class="fa fa-fw fa-refresh"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form @submit.prevent="search()">
      <div class="col-lg-9">
        <div class="panel panel-default">
          <div class="panel-heading">Details</div>
          <div class="panel-body">
            <div class="form-horizontal">
              <div class="form-group">
                <label class="control-label col-lg-2">Status</label>
                <div class="col-lg-10">
                  <toggle v-model="form.status" :disabled="fetchingData"></toggle>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-lg-2">Name</label>
                <div class="col-lg-10">
                  <input type="text" class="form-control" v-model="form.name" :disabled="fetchingData" />
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-lg-2">Title</label>
                <div class="col-lg-10">
                  <input type="text" class="form-control" v-model="form.title" :disabled="fetchingData" />
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-lg-2">Header</label>
                <div class="col-lg-10">
                  <textarea class="form-control" v-model="form.header" :disabled="fetchingData"></textarea>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-lg-2">Description</label>
                <div class="col-lg-10">
                  <ckeditor :editor="editor.instance" :config="editor.config" v-model="form.description" :disabled="fetchingData"></ckeditor>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-lg-2">Image</label>
                <div class="col-lg-4">
                  <div class="input-group">
                    <div class="input-group-btn">
                      <upload class="btn btn-default" @input="updateImage($event)" :disabled="fetchingData" title="Upload Image"></upload>
                      <button type="button" class="btn btn-default" title="View Image" @click="showImage(form.image)"><i class="fa fa-fw fa-eye"></i></button>
                    </div>
                    <input type="text" class="form-control" v-model="form.image" :disabled="fetchingData" />
                    <span class="input-group-addon">
                      <toggle class="toggle--input-group-addon" v-model="form.deleteImage" title="Delete Image"></toggle>
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 use-product-image" >
                  <a class="use-product-image__finder" href="#" @click.stop.prevent="searchProduct">Use Product Image</a>
                  <div class="use-product-image__result" v-if="useProductImage.description">
                    <span>{{ useProductImage.partNumber }}</span>
                    <span>{{ useProductImage.description }}</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-lg-2">Sort Order</label>
                <div class="col-lg-10">
                  <input type="text" class="form-control" v-model="form.sortNumber" :disabled="fetchingData" />
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-lg-2">Wholesale Restricted</label>
                <div class="col-lg-10">
                  <toggle v-model="form.wholesaleRestricted" :disabled="fetchingData"></toggle>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-lg-2">Dealers Only</label>
                <div class="col-lg-10">
                  <toggle v-model="form.dealersOnly" :disabled="fetchingData"></toggle>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-lg-2">Show Mfg</label>
                <div class="col-lg-10">
                  <toggle v-model="form.manufacturerDisplayed" :disabled="fetchingData"></toggle>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-lg-2">Layout</label>
                <div class="col-lg-10">
                  <select class="form-control" v-model="form.layout" :disabled="fetchingData">
                    <option value="1">1 Column</option>
                    <option value="2">2 Column</option>
                    <option value="3">3 Column</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="panel panel-default">
          <div class="panel-heading">Default Filter</div>
          <div class="panel-body">
            <div class="form-horizontal">
              <div class="form-group">
                <label class="control-label col-lg-2">Class</label>
                <div class="col-lg-10">
                  <select class="form-control" v-model="form.classification" :disabled="fetchingData">
                    <option value="">Select Class</option>
                    <option v-for="(label, value) in classificationOptions" :value="value" v-html="label" :key="value"></option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-lg-2">Status</label>
                <div class="col-lg-10">
                  <select class="form-control" v-model="form.stockStatus" :disabled="fetchingData">
                    <option value="">Select Status</option>
                    <option v-for="(label, value) in stockStatusOptions" :value="value" :key="value">{{ label }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <modal
      effect="zoom"
      size="large"
      v-if="dlgViewImage.load"
      :close-on-esc="true"
      :show="dlgViewImage.show"
      @close="closeImageViewer"
      @closed="dlgViewImage.load = false"
      >
      <span slot="title">View Image <small>{{ dlgViewImage.image }}</small></span>
      <div slot="content" class="clearfix text-center">
        <img v-if="!!dlgViewImage.image" :src="`/image/product/${dlgViewImage.image}?width=250`" />
      </div>
      <div slot="buttons" class="clearfix">
        <button type="button" class="btn btn-default" @click="closeImageViewer">Close</button>
      </div>
    </modal>
    <modal
      effect="zoom"
      size="medium"
      v-if="dlgDeleteCategory.load"
      :close-on-esc="true"
      :show="dlgDeleteCategory.show"
      @close="dlgDeleteCategory.show = false"
      @closed="dlgDeleteCategory.load = false"
      >
      <span slot="title">Confirm Delete Category</span>
      <div slot="content" class="clearfix text-center">
        Please confirm that you want to delete this category
      </div>
      <div slot="buttons" class="clearfix">
        <button type="button" class="btn btn-danger" @click="doDeleteCategory">YES DELETE</button>
        <button type="button" class="btn btn-default" @click="dlgDeleteCategory.show = false">No, Cancel Delete</button>
      </div>
    </modal>
    <search-product-modal
      v-if="searchProductForm.show"
      v-bind:show="searchProductForm.show"
      v-on:item-return="applyFoundProduct"
      v-on:close="closeSearchProduct"
      :p-default-form="{status: 'allactive'}"
      >
    </search-product-modal>
  </div><!-- #category-create -->
</template>

<script>
  import _ from 'lodash'
  import { mapState, mapGetters } from 'vuex'
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  import MixinApiResponse from '@/plugin/mixin/api-response'
  import Modal from '@/plugin/bootstrap/modal'
  import SearchProductModal from '@/plugin/bootstrap/search-product-modal';
  import Toggle from '@/plugin/bootstrap/toggle'
  import Upload from '@/plugin/bootstrap/upload'

  export default {
    name: 'search',
    data() {
      return {
        pageTitle: 'Category',
        form: {
          status                : false,
          name                  : '',
          title                 : '',
          header                : '',
          description           : '',
          image                 : '',
          sortNumber            : 0,
          wholesaleRestricted   : false,
          dealersOnly           : false,
          manufacturerDisplayed : false,
          layout                : '1',
          classification        : '',
          stockStatus           : '',
          upload                : null,
          deleteImage           : false,
          usePartNumber         : null
        },
        editor: {
          instance: ClassicEditor,
          config: {}
        },
        dlgViewImage: {
          load: false,
          show: false,
          image: null
        },
        dlgDeleteCategory: {
          load: false,
          show: false
        },
        searchProductForm: {
          load  : false,
          show  : false,
          result: false,
          spec  : false,
          item  : false
        },
        useProductImage: {
          productId  : null,
          inventoryId: null,
          partNumber : null,
          description: null
        }
      }
    },
    created() {
      const path = _.chain(this.$route.query).get('path').toString().value()
      const id   = _.chain(this.$route.params).get('id').toInteger().value()

      this.pageTitle = id ? 'Category' : 'New Category'
      this.$store.dispatch('app/changeTitle', this.pageTitle)

      this.$store.commit('category/form/setPath', path)
      this.$store.commit('category/form/setCategoryId', id)

      this.fetchData()
    },
    watch: {
      formData() {
        this.populateForm()
      },
      form: {
        handler(value) {
          this.$store.commit('category/form/setData', value)
        },
        deep: true
      },
      isNew(value) {
        if (value) {
          document.title = 'Category'
        } else {
          document.title = 'New Category'
        }
      }
    },
    computed: {
      ...mapState('category/form', {
        categoryId            : 'categoryId',
        formData              : 'data',
        loading               : 'loading',
        saving                : 'saving',
        loadingOptions        : 'loadingOptions',
        classificationOptions : 'classificationOptions',
        stockStatusOptions    : 'stockStatusOptions'
      }),
      ...mapGetters('category/form', {
        isNew: 'isNew'
      }),
      fetchingData() {
        return this.httpRequestOngoing
      },
      httpRequestOngoing() {
        return this.loading || this.saving || this.loadingOptions
      }
    },
    methods: {
      async reload() {
        await this.fetchData()
      },
      async fetchData() {
        await this.$store.dispatch('category/form/fetch')
      },
      populateForm() {
        _.assign(this.form, this.formData)
      },
      cancel() {
        this.back()
      },
      async saveAndExit() {
        await this.save(),
        this.back()
      },
      async save() {
        let response = await this.$store.dispatch('category/form/save')

        if ('admin-category/create' === this.$route.name) {
          this.redirectToNewCategory()
        }

        this.form.deleteImage = false

        this.clearUseProductImage()
        this.fetchData()

        return response
      },
      deleteCategory() {
        this.dlgDeleteCategory.load = true
        this.dlgDeleteCategory.show = true
      },
      async doDeleteCategory() {
        let response = await this.$store.dispatch('category/form/deleteCategory')

        this.dlgDeleteCategory.show = false
        this.back()

        return response
      },
      back() {
        let path = _.chain(this.$route.query).get('path').toString().value()

        let params = _.assign({}, this.$route.params)
        if (path) {
          params.path = path
        }

        let query = _.assign({}, this.$route.query, this.generateUniqueRouteQuery())
        if (query.path) {
          delete query.path
        }

        this.$router.push({
          name   : 'admin-category/browse',
          params : params,
          query  : query
        })
      },
      redirectToNewCategory() {
        const params = _.assign({}, this.$route.params, {id: this.categoryId})
        const query = _.assign({}, this.$route.query, this.generateUniqueRouteQuery())

        this.$router.push({
          name   : 'admin-category/update',
          params : params,
          query  : query
        })
      },
      updateImage(ev) {
        if (!ev) {
          return
        }

        this.form.image  = ev.name
        this.form.upload = ev
      },
      showImage(image) {
        this.dlgViewImage.load = true
        this.dlgViewImage.show = true
        this.dlgViewImage.image = image
      },
      closeImageViewer() {
        this.dlgViewImage.show = false
        this.dlgViewImage.image = null
      },
      searchProduct() {
        if (this.fetchingData) {
          return
        }

        this.searchProductForm.result = null
        this.searchProductForm.show   = true
      },
      applyFoundProduct(result) {
        if (this.fetchingData) {
          return
        }

        _.assign(this.useProductImage, {
          productId  : _.get(result, 'referenceProductId'),
          inventoryId: _.get(result, 'referenceInventoryId'),
          partNumber : _.get(result, 'partNumber'),
          description: _.get(result, 'description')
        })

        this.form.usePartNumber = this.useProductImage.partNumber

        this.closeSearchProduct()
      },
      closeSearchProduct() {
        this.searchProductForm.result = null
        this.searchProductForm.show   = false
      },
      clearUseProductImage() {
        this.form.usePartNumber = null
        _.assign(this.useProductImage, {
          productId   : null,
          inventoryId : null,
          partNumber  : null,
          description : null
        })
      }
    },
    components: {
      Modal,
      SearchProductModal,
      Toggle,
      Upload
    },
    mixins: [
      MixinApiResponse
    ]
  }
</script>

<style lang="scss" scoped>
.use-product-image {
  display: flex;
  flex-wrap: nowrap;

  &__finder {
    margin-right: 15px;
    min-width: 0;
    white-space: nowrap;
  }

  &__result {
    display: flex;
    min-width: 0;

    > span:first-child {
      flex-shrink: 0;
      margin-right: 5px;

      &::after {
        content: '|';
        margin-left: 5px;
      }
    }

    > span:last-child {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>>